export default "/images/framework/WordHistoryCht.d7bad28c.svg?d7bad28c";